import React, { Component } from 'react';
import Image from './../../image/Image';

class GalleryImages extends Component {
  componentDidMount() {
    this.toggleArrow(true);
  }

  toggleArrow = (firstLoad = false) => {
    const {
      scrollTop,
      scrollHeight,
      clientHeight,
    } = this.refs.galleryWrapper;

    if (scrollTop > 0) {
      this.props.toggleTopArrow(true);
    }

    if (scrollTop === 0) {
      this.props.toggleTopArrow(false);
    }

    if (firstLoad) {
      this.props.toggleBottomArrow(true);
    } else {
      /* if (scrollTop + clientHeight === scrollHeight) {
        this.props.toggleBottomArrow(false);
      } */

      if (scrollTop + clientHeight !== scrollHeight) {
        this.props.toggleBottomArrow(true);
      }
    }
  }

  renderImages = () => {
    const { images } = this.props;
    return images.map((image, index) => (<Image key={index} thumb={image.thumb} id={image.id} />));
  }

  render() {
    return (
      <div className="GalleryWrapper" ref="galleryWrapper" onScroll={() => this.toggleArrow()}>
        { this.renderImages()}
      </div>
    );
  }
}

export default GalleryImages;



// WEBPACK FOOTER //
// ./src/components/gallery/gallery-images/GalleryImages.jsx